export class configModel {
  config: config[];

  getConfigkeyname(keyText: string): string {
    if (!this.config) return '';
    let configItem = this.config.find(item => item.keyText === keyText);
    return configItem ? configItem.valText : '';
  }

}
export class config {
  configId: number;
  keyText: string;
  valText: string;
}
export class ms_Config {
  configId: number;
  keyText: string;
  valText: string;
}
